import React from 'react';
import { Select, SelectProps } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { InstitutionOption, useSearchInstitutionsSelect } from './useSearchInstitutionsSelect';

interface Props extends SelectProps<InstitutionOption, false> {
  clientId: string;
}

export const SearchInstitutionsSelect = ({ clientId, ...rest }: Props) => {
  const { loadInstitutions } = useSearchInstitutionsSelect({ clientId });

  return <Select isAsync cacheOptions loadOptions={loadInstitutions} {...rest} />;
};
